import { OFFICIAL_MARKS, PLATFORMS, type PlatformId } from '@/lib/platforms'

// Full-colour official logos for network tiles and avatar badges, built from
// the official marks in platforms.tsx. LinkedIn, Facebook and Mastodon ship a
// logo that is already a shape (square, circle, bubble), so it renders as is
// with white behind its cut-out letters. The rest render as their app icon:
// the white mark on the brand's own background.
const APP_ICON_BACKGROUND: Partial<Record<PlatformId, string>> = {
  x: '#000000',
  threads: '#000000',
  tiktok: '#000000',
  instagram: PLATFORMS.instagram.gradient,
  bluesky: '#1185FE',
  youtube: '#FF0000',
}

export function platformLogoRadius(platform: PlatformId) {
  return platform === 'facebook' ? '9999px' : platform === 'linkedin' ? '12%' : '22%'
}

export function PlatformLogo({ platform, size }: { platform: PlatformId; size: number }) {
  const p = PLATFORMS[platform]
  const box = { width: size, height: size }

  if (platform === 'linkedin') {
    return (
      <svg viewBox="0 0 48 48" style={box} className="shrink-0" role="img" aria-label="LinkedIn">
        <rect x="1" y="1" width="46" height="46" rx="4" fill="#FFFFFF" />
        <path fill={p.color} fillRule="evenodd" d={OFFICIAL_MARKS.linkedin!.d} />
      </svg>
    )
  }
  if (platform === 'facebook' || platform === 'mastodon') {
    return (
      <svg viewBox="0 0 24 24" style={box} className="shrink-0" role="img" aria-label={p.name}>
        {platform === 'facebook' ? (
          <circle cx="12" cy="12" r="11.5" fill="#FFFFFF" />
        ) : (
          <rect x="4.5" y="3.5" width="15.5" height="11.5" fill="#FFFFFF" />
        )}
        <path fill={p.color} d={OFFICIAL_MARKS[platform]!.d} />
      </svg>
    )
  }
  return (
    <span
      role="img"
      aria-label={p.name}
      className="grid shrink-0 place-items-center text-white"
      style={{ ...box, borderRadius: platformLogoRadius(platform), background: APP_ICON_BACKGROUND[platform] ?? p.gradient }}
    >
      <span className="inline-flex" style={{ width: size * 0.6, height: size * 0.6 }}>{p.icon}</span>
    </span>
  )
}
